import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { fr } from './fr';
import { en } from './en';
import { ar } from './ar';
import { arTN } from './ar-TN';
import { linaAiTranslations } from './linaAiTranslations';

const resources = {
  fr: { ...fr, linaAi: linaAiTranslations.fr },
  en: { ...en, linaAi: linaAiTranslations.en },
  ar: { ...ar, linaAi: linaAiTranslations.ar },
  'ar-TN': { ...arTN, linaAi: linaAiTranslations['ar-TN'] }
};

// A language chosen in the selector is kept (English included). Otherwise the browser decides between
// French and Arabic only; any other browser language (English, German...) and crawlers get French.
export function initialLanguage(saved, languages = [], language = '') {
  if (['fr', 'en', 'ar', 'ar-TN'].includes(saved)) return saved;
  for (const candidate of [...languages, language]) {
    const code = String(candidate || '').toLowerCase();
    if (code === 'ar-tn') return 'ar-TN';
    const base = code.split('-')[0];
    if (['fr', 'ar'].includes(base)) return base;
  }
  return 'fr';
}
const detector = new LanguageDetector();
detector.addDetector({
  name: 'preferredLanguage',
  lookup() {
    let saved;
    try { saved = window.localStorage.getItem('language'); } catch { /* Storage may be unavailable. */ }
    return initialLanguage(saved, navigator.languages, navigator.language);
  },
});


i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: ['fr', 'en', 'ar', 'ar-TN'],
    load: 'all',
    fallbackLng: 'fr',
    returnEmptyString: false,
    detection: {
      order: ['preferredLanguage'],
      lookupLocalStorage: 'language',
      caches: [],
    },
    interpolation: {
      escapeValue: false
    }
  });

// Keep direction in sync, including language changes outside the selector.
function syncDocumentLanguage(language) {
  const code = language === 'ar-TN' ? 'ar-TN' : (language || 'fr').split('-')[0];
  if (typeof document !== 'undefined') {
    document.documentElement.lang = code;
    document.documentElement.dir = code.startsWith('ar') ? 'rtl' : 'ltr';
  }
}
i18n.on('languageChanged', syncDocumentLanguage);
syncDocumentLanguage(i18n.resolvedLanguage || i18n.language);

export default i18n;
